<template>
  <!-- Footer -->
  <footer class="background text-center text-white margin-custom">
    <!-- Grid container -->
    <div class="container p-4">
      <!-- Section: Links -->
      <section class="">
        <!--Grid row-->
        <div class="row">
          <!--Grid column-->
          <div class="col-lg-3 col-md-6 mb-4 mb-md-0">
            <h5 class="text-uppercase glow">Onyxia</h5>

            <ul class="list-unstyled mb-0">
              <li>
                <a href="https://onyxia-rsps.com/files/onyxia-launcher.jar"
                  >Download Onyxia</a
                >
              </li>
              <li>
                <a href="https://onyxia-rsps.com/vote">Vote for Onyxia</a>
              </li>
              <li>
                <a
                  href="https://www.rune-server.ee/runescape-development/rs-503-client-server/advertise/689606-atrox-rsps-osrs-items-6-game-modes-best-pre-eoc-server.html"
                  >Game Media</a
                >
              </li>
              <li>
                <a href="https://onyxia-rsps.com/store">Store</a>
              </li>
            </ul>
          </div>
          <!--Grid column-->

          <!--Grid column-->
          <div class="col-lg-3 col-md-6 mb-4 mb-md-0">
            <h5 class="text-uppercase glow">Community</h5>

            <ul class="list-unstyled mb-0">
              <li>
                <a href="https://www.facebook.com/groups/infernalrsps"
                  >Facebook</a
                >
              </li>
              <li>
                <a href="https://onyxia-rsps.com/hiscores">Hiscores</a>
              </li>
              <li>
                <a href="#!">Youtube</a>
              </li>
              <li>
                <a href="https://discord.gg/xDneeVewQ3">Discord</a>
              </li>
            </ul>
          </div>
          <!--Grid column-->

          <!--Grid column-->
          <div class="col-lg-3 col-md-6 mb-4 mb-md-0">
            <h5 class="text-uppercase glow">Help</h5>

            <ul class="list-unstyled mb-0">
              <li>
                <a href="#!">Rules</a>
              </li>
              <li>
                <a href="#!">Privacy Policy</a>
              </li>
              <li>
                <a href="#!">Report a player</a>
              </li>
              <li>
                <a href="#!">Report a bug</a>
              </li>
            </ul>
          </div>
          <!--Grid column-->

          <!--Grid column-->
          <div class="col-lg-3 col-md-6 mb-4 mb-md-0">
            <h5 class="text-uppercase">Ready to start your adventure?</h5>
            <button class="glow-on-hover mb-5">
              <a
                href="https://onyxia-rsps.com/files/onyxia-launcher.jar"
                class="text-white"
                download
              >
                Play Now
              </a>
            </button>
          </div>
          <!--Grid column-->
        </div>
        <!--Grid row-->
      </section>
      <!-- Section: Links -->
    </div>
    <!-- Grid container -->

    <!-- Copyright -->
    <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2)">
      © 2021 Copyright: Onyxia-PS |
      <a class="text-white" href="https://github.com/Th3mike" target="_blank"
        >Developed by Th3Mike</a
      >
    </div>
    <!-- Copyright -->
  </footer>
  <!-- Footer -->
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped>
a {
  color: white;
  text-decoration: none;
}
a:hover {
  color: orange;
}
footer {
  width: 100%;
  position: relative;
  bottom: 0;
  left: 0;
}
.background {
  background-color: rgba(0, 0, 0, 0.842);
}
.margin-custom {
  margin-top: 50px;
}
.glow {
  color: #fff;
  text-align: center;
  animation: glow 1s ease-in-out infinite alternate;
}

@-webkit-keyframes glow {
  from {
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #e60073,
      0 0 40px #e60073, 0 0 50px #e60073, 0 0 60px #e60073, 0 0 70px #e60073;
  }

  to {
    text-shadow: 0 0 20px #fff, 0 0 30px #ff4da6, 0 0 40px #ff4da6,
      0 0 50px #ff4da6, 0 0 60px #ff4da6, 0 0 70px #ff4da6, 0 0 80px #ff4da6;
  }
}
.glow-on-hover {
  width: 220px;
  height: 50px;
  border: none;
  outline: none;
  color: #fff;
  background: #111;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border-radius: 10px;
  font-size: 30px;
}

.glow-on-hover:before {
  content: "";
  background: linear-gradient(
    45deg,
    #ffffff,
    #ffffff,
    #ffffff,
    #66ff00,
    #66ff00,
    #ffffff,
    #66ff00,
    #66ff00,
    #ffffff
  );
  position: absolute;
  top: -2px;
  left: -2px;
  background-size: 400%;
  z-index: -1;
  filter: blur(5px);
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  animation: glowing 20s linear infinite;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  border-radius: 10px;
}

.glow-on-hover:active {
  color: #000;
}

.glow-on-hover:active:after {
  background: transparent;
}

.glow-on-hover:hover:before {
  opacity: 1;
}

.glow-on-hover:after {
  z-index: -1;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgb(17, 17, 17);
  left: 0;
  top: 0;
  border-radius: 10px;
}

@keyframes glowing {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 400% 0;
  }
  100% {
    background-position: 0 0;
  }
}
@media only screen and (max-width: 1280px) {
}
@media only screen and (max-width: 600px) {
  footer {
    height: 750px;
  }
  .glow {
    display: none;
  }
}
</style>